import type { ComputedRef, Ref, WritableComputedRef } from 'vue'
import { computed } from 'vue'

interface OptionLike<T> {
  value: T
}

/** Bridges a string model field and a WdsSelect's `{ label, value }` v-model. */
export function useSelectOption<T extends string, O extends OptionLike<T>>(
  model: Ref<T | ''>,
  options: Ref<O[]> | ComputedRef<O[]>,
  onChange?: (option: O | null) => void,
): WritableComputedRef<O | null> {
  return computed<O | null>({
    get: () => (model.value ? options.value.find((opt) => opt.value === model.value) ?? null : null),
    set: (option) => {
      // eslint-disable-next-line no-param-reassign
      model.value = (option?.value ?? '') as T | ''
      onChange?.(option)
    },
  })
}
